var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileDevIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.604,
    height: 211.219,
    viewBox: "0 0 121.604 211.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9802",
    "data-name": "Group 9802",
    transform: "translate(-232.352 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M634.95,135.618H633.79V103.825a18.4,18.4,0,0,0-18.4-18.4H548.032a18.4,18.4,0,0,0-18.4,18.4V278.242a18.4,18.4,0,0,0,18.4,18.4h67.357a18.4,18.4,0,0,0,18.4-18.4V158.248h1.161Z",
    transform: "translate(-289.137 -85.424)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M642.292,115.661V289.822a13.742,13.742,0,0,1-13.742,13.742H560.869a13.742,13.742,0,0,1-13.742-13.742V115.661a13.742,13.742,0,0,1,13.742-13.742h8.211a6.532,6.532,0,0,0,6.045,8.994h38.588a6.532,6.532,0,0,0,6.045-8.994h8.791a13.742,13.742,0,0,1,13.742,13.742Z",
    transform: "translate(-301.555 -97.132)",
    fill: "#717c91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10349",
    "data-name": "Path 10349",
    d: "M584.194,157.575a9.287,9.287,0,0,0,0,18.574h0a9.287,9.287,0,1,0,0-18.574Z",
    transform: "translate(-321.273 -136.635)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10350",
    "data-name": "Path 10350",
    d: "M714.326,205.22H665.568a2.322,2.322,0,0,1,0-4.644h48.758a2.322,2.322,0,1,1,0,4.644Z",
    transform: "translate(-383.974 -167.156)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M680.95,171.22H665.568a2.322,2.322,0,0,1,0-4.644H680.95a2.322,2.322,0,0,1,0,4.644Z",
    transform: "translate(-383.974 -143.024)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10352",
    "data-name": "Path 10352",
    d: "M584.194,291.575a9.287,9.287,0,0,0,0,18.574h0a9.287,9.287,0,1,0,0-18.574Z",
    transform: "translate(-321.273 -231.745)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10353",
    "data-name": "Path 10353",
    d: "M714.326,339.22H665.568a2.322,2.322,0,0,1,0-4.644h48.758a2.322,2.322,0,1,1,0,4.644Z",
    transform: "translate(-383.974 -262.266)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10354",
    "data-name": "Path 10354",
    d: "M680.95,305.22H665.568a2.322,2.322,0,0,1,0-4.644H680.95a2.322,2.322,0,0,1,0,4.644Z",
    transform: "translate(-383.974 -238.134)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10355",
    "data-name": "Path 10355",
    d: "M584.194,559.576a9.287,9.287,0,1,0,0,18.574h0a9.287,9.287,0,1,0,0-18.574Z",
    transform: "translate(-321.273 -421.966)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10356",
    "data-name": "Path 10356",
    d: "M714.326,607.22H665.568a2.322,2.322,0,1,1,0-4.643h48.758a2.322,2.322,0,1,1,0,4.643Z",
    transform: "translate(-383.974 -452.486)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10357",
    "data-name": "Path 10357",
    d: "M680.95,573.22H665.568a2.322,2.322,0,0,1,0-4.644H680.95a2.322,2.322,0,0,1,0,4.644Z",
    transform: "translate(-383.974 -428.353)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10358",
    "data-name": "Path 10358",
    d: "M584.194,693.576a9.287,9.287,0,0,0,0,18.574h0a9.287,9.287,0,1,0,0-18.574Z",
    transform: "translate(-321.273 -517.075)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10359",
    "data-name": "Path 10359",
    d: "M714.326,741.22H665.568a2.322,2.322,0,0,1,0-4.644h48.758a2.322,2.322,0,1,1,0,4.644Z",
    transform: "translate(-383.974 -547.596)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10360",
    "data-name": "Path 10360",
    d: "M680.95,707.22H665.568a2.322,2.322,0,0,1,0-4.644H680.95a2.322,2.322,0,0,1,0,4.644Z",
    transform: "translate(-383.974 -523.463)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10361",
    "data-name": "Path 10361",
    d: "M618.393,423.141H506.366a4.794,4.794,0,0,1-4.789-4.789V382.365a4.794,4.794,0,0,1,4.789-4.789H618.393a4.794,4.794,0,0,1,4.789,4.789v35.988A4.794,4.794,0,0,1,618.393,423.141Z",
    transform: "translate(-269.225 -292.786)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10362",
    "data-name": "Path 10362",
    d: "M584.194,424.076a9.287,9.287,0,0,0,0,18.574h0a9.287,9.287,0,1,0,0-18.574Z",
    transform: "translate(-321.273 -325.791)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10363",
    "data-name": "Path 10363",
    d: "M714.326,471.72H665.568a2.322,2.322,0,0,1,0-4.644h48.758a2.322,2.322,0,1,1,0,4.644Z",
    transform: "translate(-383.974 -356.311)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M680.95,437.72H665.568a2.322,2.322,0,0,1,0-4.644H680.95a2.322,2.322,0,0,1,0,4.644Z",
    transform: "translate(-383.974 -332.179)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10365",
    "data-name": "Path 10365",
    d: "M618.393,423.141H506.366a4.794,4.794,0,0,1-4.789-4.789V382.365a4.794,4.794,0,0,1,4.789-4.789H618.393a4.794,4.794,0,0,1,4.789,4.789v35.988A4.794,4.794,0,0,1,618.393,423.141ZM506.366,377.866a4.5,4.5,0,0,0-4.5,4.5v35.988a4.5,4.5,0,0,0,4.5,4.5H618.393a4.5,4.5,0,0,0,4.5-4.5V382.365a4.5,4.5,0,0,0-4.5-4.5Z",
    transform: "translate(-269.225 -292.786)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M594.85,449.152a1.128,1.128,0,0,1-.678-.225l-.012-.009-2.554-1.954a1.135,1.135,0,0,1,1.381-1.8l1.654,1.269,3.909-5.1a1.135,1.135,0,0,1,1.591-.21h0l-.024.034.025-.034a1.136,1.136,0,0,1,.21,1.591l-4.6,6a1.135,1.135,0,0,1-.9.443Z",
    transform: "translate(-332.81 -337.723)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDevIos);
export default __webpack_public_path__ + "static/media/mobile-dev-ios.6b904e17da085a45b188bfe2c875a204.svg";
export { ForwardRef as ReactComponent };